import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

export type NotificationType = "success" | "error";

export interface Notification {
  header: string;
  message: string;
  type: NotificationType;
}

interface NotificationContextType {
  notification: Notification | null;
  showNotification: (
    header: string,
    message: string,
    type: NotificationType
  ) => void;
  closeNotification: () => void;
}

const ProfileNotificationsContext =
  createContext<NotificationContextType | null>(null);

export function useProfileNotificationsContext(): NotificationContextType {
  const context = useContext(ProfileNotificationsContext);
  if (!context) {
    throw new Error("No context available");
  }
  return context;
}

export const ProfileNotificationProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [notification, setNotification] = useState<Notification | null>(null);

  const showNotification = (
    header: string,
    message: string,
    type: NotificationType
  ) => {
    setNotification({ header, message, type });
  };

  const closeNotification = () => {
    setNotification(null);
  };

  return (
    <ProfileNotificationsContext.Provider
      value={{ notification, showNotification, closeNotification }}
    >
      {children}
    </ProfileNotificationsContext.Provider>
  );
};
